module.exports = __webpack_public_path__ + "static/thpkleafmuslin-31ede3f0c81657d217ec0f3994f76c67.jpeg";